import { Route, Routes } from 'react-router';
import Config, { type MultiLang } from '../config';
import About from '../custom/About';
import D3Forum from '../d3forum/D3Forum';
import D3ForumXoopsPathRedirect from '../d3forum/D3ForumXoopsPathRedirect';
import Database from '../database/Database';
import DatabaseXoopsPathRedirect from '../database/DatabaseXoopsPathRedirect';
import XoopsPathRedirect from './XoopsPathRedirect';

interface Props {
    lang: MultiLang;
}

const MainContent = (props: Props) => {
    const { lang } = props;
    return (
        <div className="mainContent">
            <Routes>
                <Route path="/database/*" element={<Database lang={lang} />} />
                {Config.D3FORUM_MODULES.map((name) => (
                    <Route key={name} path={`/${name}/*`} element={<D3Forum lang={lang} name={name} />} />
                ))}
                <Route path="/about" element={<About lang={lang} />} />
                <Route path="/modules/xoonips/*" element={<DatabaseXoopsPathRedirect lang={lang} />} />
                {Config.D3FORUM_MODULES.map((name) => (
                    <Route
                        key={name}
                        path={`/modules/${name}/*`}
                        element={<D3ForumXoopsPathRedirect lang={lang} name={name} />}
                    />
                ))}
                <Route path="*" element={<XoopsPathRedirect lang={lang} />} />
            </Routes>
        </div>
    );
};

export default MainContent;
